import {
  Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges,
} from '@angular/core';
import dayjs from 'dayjs';
import { AbstractFilterElementComponent, FilterEmitterType } from './abstract-filter-element.component';
import { FilterElementSize, gridClassesForFilterElementSize } from './filter-elements';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { FloatLabel } from 'primeng/floatlabel';
import { DatePicker } from 'primeng/datepicker';

@Component({
  selector: 'date-range-filter-element',
  templateUrl: './date-range-filter-element.component.html',
  styleUrls: ['./date-range-filter-element.component.scss'],
  imports: [
    FormsModule,
    TranslatePipe,
    FloatLabel,
    DatePicker,
  ],
})
export class DateRangeFilterElementComponent extends AbstractFilterElementComponent implements OnInit, OnChanges {
  @HostBinding('class')
  override componentClass = '';

  @Input()
  override size: FilterElementSize = FilterElementSize.LARGE;

  @Input()
  override label: string | undefined;

  @Input()
  override filterActive = false;

  @Input()
  override filterKey!: string;

  @Input()
  start = true;

  @Input()
  end = true;

  @Output()
  override filterTerm: EventEmitter<FilterEmitterType> = new EventEmitter();

  override value: (Date|undefined)[] = [undefined, undefined];

  ngOnInit(): void {
    if (this.start && this.end) {
      this.value = [];
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['size']) {
      this.componentClass = gridClassesForFilterElementSize(changes['size'].currentValue);
    }
  }

  override onFilterChange(change: (Date|undefined)[]): void {
    if (!change[0] && !change[1]) {
      this.filterTerm.emit({ key: this.filterKey, term: undefined });
    } else if (change[0] && change[1]) {
      this.filterTerm.emit({
        key: this.filterKey,
        term: `${this.filterKey}()${dayjs(change[0]).toISOString()};${dayjs(change[1]).toISOString()}-and`,
      });
    } else if (change[0]) {
      this.filterTerm.emit({ key: this.filterKey, term: `${this.filterKey}>=${dayjs(change[0]).toISOString()}-and` });
    } else if (change[1]) {
      this.filterTerm.emit({ key: this.filterKey, term: `${this.filterKey}<=${dayjs(change[1]).toISOString()}-and` });
    }
  }
}